import { Component } from "@angular/core";

@Component({
    selector: "app-helpErupi-popup",
    templateUrl: "./helpErupi-popup.component.html",
    styleUrls: ["./helpErupi-popup.component.scss"],
    standalone: false
})
export class HelpErupiPopupComponent {
  activePanel: string = "activate_voucher";

  employeeManagementPanel(selectedTab): void {
    this.activePanel = selectedTab;
  }
}
